<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Excluidos</strong>
          </div>
          <modal-select label="Distribuidor" modal="dealers-modal" v-validate="'required'" name="dealer_id" v-bind:readonly="false" v-bind:item-id="item.dealer_id" v-bind:item-name="item.dealer.data.name" v-on:select-item="selectDealer"  :state="validateState('dealer_id')"  ></modal-select>
          <modal-select  label="Grupo de Operadores"  modal="operator-groups-modal" name="operator_group_id" v-bind:readonly="false" v-bind:item-id="item.operator_group_id" v-bind:item-name="item.operatorgroup.data.name" v-on:select-item="selectOperatorGroup"  :state="validateState('operator_group_id')"  ></modal-select>
          <b-form-group label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-row>
            <b-form-group class="col-sm-4" label="Perfil">
              <b-form-select :options="lists.yesNo" name="is_profiled" v-model="item.is_profiled" placeholder="Perfil"  v-validate="'required'" :state="validateState('is_profiled')" ></b-form-select>
              <b-form-invalid-feedback>
                {{ errors.first('is_profiled') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="col-sm-4" label="Não identificado">
              <b-form-select :options="lists.yesNo" name="unidentified" v-model="item.unidentified" placeholder="Não identificado"  v-validate="'required'" :state="validateState('unidentified')" ></b-form-select>
              <b-form-invalid-feedback>
                {{ errors.first('unidentified') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>
          <b-form-row>
            <b-form-group class="col-sm-4" label="NIF">
              <b-form-input type="text" name="nif" v-model="item.nif" placeholder="NIF"  v-validate="'required'" :state="validateState('nif')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('nif') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="col-sm-4" label="LE">
              <b-form-input type="text" name="le" v-model="item.le" placeholder="LE"  v-validate="'required'" :state="validateState('le')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('le') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="col-sm-4" label="Codle">
              <b-form-input type="text" name="codle" v-model="item.codle" placeholder="Codle"  v-validate="'required'" :state="validateState('codle')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('codle') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>

          <b-form-row>
            <b-form-group class="col-sm-6" label="Email">
              <b-form-input type="text" name="email" v-model="item.email" placeholder="Email"  v-validate="'email'" :state="validateState('email')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('email') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="col-sm-6" label="Telefone">
              <b-form-input type="text" name="phone" v-model="item.phone" placeholder="Telefone" :state="validateState('phone')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('phone') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>
          <b-form-row>
            <b-form-group class="col-sm-9" label="Morada">
              <b-form-input type="text" name="address" v-model="item.address" placeholder="Morada" :state="validateState('address')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('address') }}
              </b-form-invalid-feedback>
            </b-form-group>

          </b-form-row>
          <b-form-row>
            <b-form-group class="col-sm-3" label="Código postal">
              <b-form-input type="text" name="zip_code" v-model="item.zip_code" placeholder="Código postal" :state="validateState('zip_code')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('zip_code') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="col-sm-6" label="Localidade">
              <b-form-input type="text" name="locality" v-model="item.locality" placeholder="Localidade" :state="validateState('locality')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('locality') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'dsr.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Voltar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <!--<b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>-->
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card title="Debug">
          <pre>{{ item }}</pre>
        </b-card>
      </b-col>
    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'OperatorsEdit',
  props: ['id'],
  data() {
    return {
      dataLoaded: false,
      item: {
        name: '',
        code: '',
        dealer_id: '',
        operator_group_id: '',
        operatorgroup: {
          data: { name: '', code:'', id:'' }
        },
        dealer: {
          data: { name: '', code:'', id:'' }
        }
      },
      lists: lists
    }
  },
  methods: {
    selectDealer(e) {
      if(e.item) {
        this.item.dealer_id = e.item.id
        this.item.dealer.data = e.item
      } else {
        this.item.dealer_id = null
        this.item.dealer.data = {id: null, name:null}
      }
    },
    selectOperatorGroup(e) {
      if(e.item) {
        this.item.operator_group_id = e.item.id
        this.item.operatorgroup.data = e.item
      } else {
        this.item.operator_group_id = null
        this.item.operatorgroup.data = {id: null, name:null}
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('operators' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'operators.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('operators', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'operators.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('operators' + '/' + id)
        .then(response => {
          this.item = response.data.data
          if(!this.item.dealer) {
            this.item.dealer = { data: { name: '', code:'', id:'' } }
          }
          if(!this.item.operatorgroup) {
            this.item.operatorgroup = { data: { name: '', code:'', id:'' } }
          }
          this.dataLoaded = true

        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'operators.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
